import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { toast } from "sonner";
import { ChevronsUpDown, Check } from "lucide-react";

let _cache = null; // lista curta (249 países) — buscada uma única vez por sessão de página

// País (ISO 3166-1 alpha-2) — usado pelo tomador/intermediário no exterior e
// pelo local da prestação no exterior (Editor completo, item 3/4). Lista
// curta o bastante para não precisar de paginação (ver
// backend/integrations/nfse_nacional/paises.py) — filtro no cliente sobre
// o resultado já validado pelo backend.
export default function PaisCombobox({ value, onChange, testId = "nfse-pais" }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [items, setItems] = useState(_cache || []);

  useEffect(() => {
    if (_cache) return;
    (async () => {
      try {
        const { data } = await api.get("/config/fiscal/nfse/paises");
        _cache = data.resultados || [];
        setItems(_cache);
      } catch (e) {
        toast.error(formatApiError(e));
      }
    })();
  }, []);

  const q = query.trim().toLowerCase();
  const filtrados = q ? items.filter((p) => p.nome.toLowerCase().includes(q) || p.codigo.toLowerCase() === q) : items;
  const atual = items.find((p) => p.codigo === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between font-normal text-left" data-testid={testId}>
          <span className="truncate">{atual ? atual.exibicao : (value || "Selecione o país...")}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[320px] max-w-[92vw] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Buscar país..." value={query} onValueChange={setQuery} data-testid={`${testId}-busca`} />
          <CommandList>
            <CommandEmpty>Nenhum país encontrado.</CommandEmpty>
            <CommandGroup>
              {filtrados.slice(0, 100).map((p) => (
                <CommandItem key={p.codigo} value={p.codigo} onSelect={() => { onChange(p.codigo); setOpen(false); setQuery(""); }} data-testid={`${testId}-opcao-${p.codigo}`}>
                  <Check className={`mr-2 h-4 w-4 shrink-0 ${value === p.codigo ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{p.exibicao}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
